// 项目分配
<template>
  <div class="projectFormLess" v-if="isComponentsShow">
    <!-- 第一行-企业全称 -->
    <div class="oneRow" style="margin-bottom:35px">
      <div class="leftLabel">
        <img style="width:17px" src="../../assets/image/icon_gs@2x.png" alt />
        <span>企业全称</span>
      </div>
      <div class="rightInput">
        <el-input disabled v-model="addFormData.company_name"></el-input>
      </div>
    </div>
    <!-- 项目登记人 -->
    <div class="oneRow" style="margin-bottom:20px" v-if="addFormData.member">
      <div class="leftLabel">
        <img style="width:16px" src="../../assets/image/icon_zhmc@2x.png" alt />
        <span>项目登记人</span>
      </div>
      <div class="rightInput">
        <span class="isNotSubmitSpan">{{addFormData.member.nickname}}</span>
      </div>
    </div>
    <!-- 第二行-内部业务人员and外部业务员 -->
    <div class="towRow" style="margin-bottom:35px">
      <div class="towRowBox">
        <div class="leftLabel">
          <img style="width:16px" src="../../assets/image/icon_zhmc@2x.png" alt />
          <span>内部业务人员</span>
        </div>
        <div class="rightInput">
          <el-input
            disabled
            v-if="addFormData.inside_salesman"
            v-model="addFormData.inside_salesman.nickname"
          ></el-input>
          <el-input disabled v-else></el-input>
        </div>
      </div>
      <div class="towRowBox">
        <div class="leftLabel leftLabel2">
          <img style="width:16px" src="../../assets/image/icon_zhmc@2x.png" alt />
          <span>外部业务人员</span>
        </div>
        <div class="rightInput">
          <el-input disabled v-model="addFormData.external_salesman"></el-input>
        </div>
      </div>
    </div>
    <!-- 第三行--项目类型and许可类型 -->
    <div class="towRow" style="margin-bottom:35px">
      <div class="towRowBox">
        <div class="leftLabel">
          <img style="width:16px" src="../../assets/image/icon_xmlx@2x.png" alt />
          <span>项目类型</span>
        </div>
        <div class="rightInput">
          <el-select v-model="addFormData.project_type_id" disabled>
            <el-option
              v-for="item in projectTypeList"
              :key="item.project_type_id"
              :label="item.project_type_name"
              :value="item.project_type_id"
            ></el-option>
          </el-select>
        </div>
      </div>
      <div class="towRowBox">
        <div class="leftLabel leftLabel2">
          <img style="width:15px" src="../../assets/image/icon_xklx@2x.png" alt />
          <span>许可类型</span>
        </div>
        <div class="rightInput">
          <el-select v-model="addFormData.permit_type" disabled>
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </div>
      </div>
    </div>
    <!-- 第四行--联系方式and企业联系人 -->
    <div class="towRow" style="margin-bottom:35px">
      <div class="towRowBox">
        <div class="leftLabel">
          <img style="width:14px" src="../../assets/image/icon_lxr@2x.png" alt />
          <span>项目联系人</span>
        </div>
        <div class="rightInput">
          <el-input disabled v-model="addFormData.contacts"></el-input>
        </div>
      </div>
      <div class="towRowBox">
        <div class="leftLabel leftLabel2">
          <img style="width:13px" src="../../assets/image/icon_sjzh@2x.png" alt />
          <span>联系电话</span>
        </div>
        <div class="rightInput">
          <el-input disabled v-model="addFormData.contact_number"></el-input>
        </div>
      </div>
    </div>
    <!-- 第五行--上传附件 -->
    <div class="oneRow" style="margin-bottom:35px">
      <div class="leftLabel upLoadLabel">
        <img style="width:14px" src="../../assets/image/icon_fj@2x.png" alt />
        <span>附件</span>
      </div>
      <div class="rightInput">
        <!-- <ul class="fileList">
          <li v-for="item in detailsImgList">
            <div class="FileBox">
              <img
                src="../../assets/image/icon_pdf@2x.png"
                v-if="item.type==='png' || item.type==='PNG'"
                alt
              />
              <span>{{item.name}}</span>
            </div>
          </li>
        </ul>-->
        <upload-file
          :isSubmit="false"
          :imgList="this.addFormData.annex"
          :detailsImgList="detailsImgList"
          @my-upload-change="upLoadChange"
        ></upload-file>
      </div>
    </div>
    <!-- 第六行--添加备注 -->
    <div class="oneRow" style="margin-bottom:35px">
      <div class="leftLabel">
        <img style="width:15px" src="../../assets/image/icom_jj@2x.png" alt />
        <span>添加备注</span>
      </div>
      <div class="rightInput">
        <el-input disabled v-model="addFormData.remark"></el-input>
      </div>
    </div>
    <!-- 第七行-内部项目编号 -->
    <div class="oneRow" style="margin-bottom:30px">
      <div class="leftLabel">
        <img style="width:16px" src="../../assets/image/icon_bh@2x.png" alt />
        <span>内部项目编号</span>
      </div>
      <div class="rightInput">
        <el-input disabled v-model="addFormData.project_code"></el-input>
      </div>
    </div>
    <!-- 沿用上次分配 -->
    <div
      class="oneRow"
      style="margin-bottom:30px"
      v-if="addFormData.is_allocation==1 && addFormData.is_approval==1"
    >
      <div class="leftLabel"></div>
      <div class="rightInput">
        <el-button @click="userLast">沿用上次管理</el-button>
      </div>
    </div>
    <!-- 第八行--项目管理 -->
    <div class="oneRow" style="margin-bottom:30px">
      <div class="leftLabel">
        <img style="width:14px" src="../../assets/image/icon_jishu@2x.png" alt />
        <span>项目管理</span>
      </div>
      <div class="rightInput">
        <one-transfer
          v-if="addFormData.is_approval==1 && addFormData.is_allocation==1"
          style="width:100%"
          :selectedId="leader"
          :selectedName="leader_name"
          :memberNickname="addFormData.member.nickname"
          @my-transfer-change="transferChange1"
        ></one-transfer>
        <span v-else class="isNotSubmitSpan">{{addFormData.leader_detail.nickname}}</span>
      </div>
    </div>
    <!-- 马总提示 -->
    <!-- v-if="addFormData.is_allocation==1 && addFormData.is_approval==1" -->
    <div class="oneRow" style="margin-bottom:15px">
      <div class="leftLabel"></div>
      <div class="rightInput">
        <div
          style="color:rgb(245, 95, 95);margin-bottom:15px;font-size:12px"
        >*您可以选择只分配“项目管理”,由"项目管理"进行"项目主办"的分配</div>
      </div>
    </div>
    <!-- 第八行--项目主办 -->
    <div class="oneRow" style="margin-bottom:30px">
      <div class="leftLabel">
        <img style="width:14px" src="../../assets/image/icon_zhmc@2x.png" alt />
        <span>项目主办</span>
      </div>
      <div class="rightInput">
        <one-transfer
          v-if="(addFormData.is_approval==1 || addFormData.is_approvall==1) && addFormData.is_allocation==1"
          :memberNickname="addFormData.member.nickname"
          :selectedName="evaluators_name"
          :selectedId="evaluators"
          style="width:100%"
          @my-transfer-change="transferChange"
        ></one-transfer>
        <span
          v-if="addFormData.is_allocation==0 && addFormData.evaluators_detail"
          class="isNotSubmitSpan"
        >{{addFormData.evaluators_detail.nickname}}</span>
      </div>
    </div>
    <!-- 第九行--状态 -->
    <div class="oneRow" style="margin-bottom:30px">
      <div class="leftLabel">
        <img style="width:16px" src="../../assets/image/icon_zt@2x.png" alt />
        <span>状态</span>
      </div>
      <div class="rightInput">
        <!-- <el-input v-model="infop"></el-input> -->
        <span
          v-if="details_project_status=='12' && addFormData.is_allocation==1"
          class="isNotSubmitSpan"
        >待分配</span>
        <span
          v-if="details_project_status=='12' && addFormData.is_allocation==0 && addFormData.is_edit==1"
          class="isNotSubmitSpan"
        >待接受</span>
        <span
          v-if="details_project_status=='13' && addFormData.is_allocation==0 && addFormData.is_edit==1"
          class="isNotSubmitSpan"
        >已接受</span>
        <!-- <span
          v-if="details_project_status=='13' && addFormData.is_allocation==0 && addFormData.is_edit==1"
          class="isNotSubmitSpan"
        >已分配</span>-->
      </div>
    </div>
    <!-- 第九行--拒绝原因 -->
    <div
      class="oneRow"
      style="margin-bottom:50px"
      v-if="addFormData.is_allocation!=1 && member_id==addFormData.evaluators && addFormData.is_accecpt==1"
    >
      <div class="leftLabel">
        <img style="width:14px" src="../../assets/image/icon_juj@2x.png" alt />
        <span>拒绝原因</span>
      </div>
      <div class="rightInput">
        <el-input placeholder="请输入拒绝原因" v-model="reasonForRefusal"></el-input>
      </div>
    </div>
    <!-- 按钮行 -->
    <div class="btnRow">
      <el-button v-if="addFormData.is_accecpt==1" @click="takeSubmit('-1')">拒 绝</el-button>
      <el-button
        v-if="addFormData.is_accecpt==1"
        style="background-color:#40A0F2"
        @click="takeSubmit('1')"
      >接 受</el-button>
      <el-button
        v-if="addFormData.is_allocation==1 && addFormData.is_approval==1"
        style="background-color:#40A0F2"
        @click="distributionSubmit1"
      >分 配</el-button>
      <el-button
        v-if="addFormData.is_allocation==1 && addFormData.is_approvall==1"
        style="background-color:#40A0F2"
        @click="distributionSubmit2"
      >分 配</el-button>
    </div>
    <!-- 按钮行 -->

    <!-- 查看进度 -->
    <project-flow
      v-if="this.addFormData.approval_log && this.addFormData.approval_log.length>0"
      :projectFlowLog="this.addFormData.approval_log"
      :projectName="this.addFormData.project_name"
      :companyName="this.addFormData.company_name"
      :projectId="this.addFormData.project_id"
      :stageCode="'12'"
    ></project-flow>
    <go-finance
      v-if="this.addFormData.approval_log && this.addFormData.approval_log.length>0"
      :projectId="this.addFormData.project_id"
    ></go-finance>
  </div>
</template>
<script>
import ProjectFlow from '../ProjectFlow'
import GoFinance from '../GoFinance'
import OneTransfer from '../OneTransfer'
import UploadFile from '../UploadFile'
export default {
  data() {
    return {
      tiemID: null,
      timeDou: 100,
      // 拒绝原因、
      reasonForRefusal: '',
      evaluators: '',
      evaluators_name: '',
      leader: '',
      leader_name: '',
      infop: '',
      token: '',
      member_id: '',
      company_id: '',
      cache_department_id: '',
      details_project_status: '',
      details_project_id: '',
      detailsImgList: [],
      projectTypeList: [],
      addFormData: {},
      value: '',
      options: [
        {
          value: '2',
          label: '许可类',
        },
        {
          value: '1',
          label: '一般类',
        },
      ],
      isComponentsShow: false,
    }
  },
  methods: {
    userLast() {
      // btlh_process_userLast_leader
      // btlh_process_userLast_evaluators
      this.evaluators =
        localStorage.getItem('btlh_process_userLast_evaluators') || ''
      this.evaluators_name =
        localStorage.getItem('btlh_process_userLast_evaluators_name') || ''
      this.leader = localStorage.getItem('btlh_process_userLast_leader') || ''
      this.leader_name =
        localStorage.getItem('btlh_process_userLast_leader_name') || ''
      console.log('')
    },
    // *接受and拒绝提交
    async takeSubmit(val) {
      clearTimeout(this.tiemID)
      this.tiemID = setTimeout(async () => {
        let param = new URLSearchParams()
        param.append('member_id', this.member_id)
        param.append('token', this.token)
        if (this.$store.state.process.app.deviceInfo) {
          param.append('device', this.$store.state.process.app.deviceInfo)
        } else {
          param.append('device', 'pc')
        }
        param.append('cache_department_id', this.cache_department_id)
        param.append('company_id', this.company_id)
        param.append('project_id', this.details_project_id)

        param.append('approval_status', val)
        param.append('remark', this.reasonForRefusal)
        const { data: res } = await this.$axios({
          method: 'post',
          url: '/api/Project/allocation_accecpt',
          data: param,
        })
        if (res.code != 200) return this.$message.error(res.datas.msg)
        this.$message.success(res.datas.msg)
        // this.$router.push('/project/index')
        this.getProjectStatus()
        this.getProjectDetails()
      }, this.timeDou)
    },
    // *项目分配提交(一阶段)
    async distributionSubmit1() {
      // if (!this.evaluators) return this.$message.error('请选择技术负责人')
      clearTimeout(this.tiemID)
      this.tiemID = setTimeout(async () => {
        let param = new URLSearchParams()
        param.append('member_id', this.member_id)
        param.append('token', this.token)
        if (this.$store.state.process.app.deviceInfo) {
          param.append('device', this.$store.state.process.app.deviceInfo)
        } else {
          param.append('device', 'pc')
        }
        param.append('cache_department_id', this.cache_department_id)
        param.append('company_id', this.company_id)
        param.append('project_id', this.details_project_id)

        param.append('evaluators', this.evaluators)
        param.append('leader', this.leader)
        const { data: res } = await this.$axios({
          method: 'post',
          url: '/api/Project/allocation_elpart',
          data: param,
        })
        if (res.code != 200) return this.$message.error(res.datas.msg)
        this.$message.success(res.datas.msg)
        window.localStorage.setItem(
          'btlh_process_userLast_evaluators',
          this.evaluators
        )
        window.localStorage.setItem(
          'btlh_process_userLast_evaluators_name',
          this.evaluators_name
        )
        window.localStorage.setItem('btlh_process_userLast_leader', this.leader)
        window.localStorage.setItem(
          'btlh_process_userLast_leader_name',
          this.leader_name
        )
        if (this.$route.query.from == 'myFlow') {
          this.$router.go(-1) //返回上一层
        }
        // this.$router.push('/project/index')
        this.getProjectStatus()
        this.getProjectDetails()
      }, this.timeDou)
    },
    // *项目分配提交(二阶段)
    async distributionSubmit2() {
      // if (!this.evaluators) return this.$message.error('请选择技术负责人')
      clearTimeout(this.tiemID)
      this.tiemID = setTimeout(async () => {
        let param = new URLSearchParams()
        param.append('member_id', this.member_id)
        param.append('token', this.token)
        if (this.$store.state.process.app.deviceInfo) {
          param.append('device', this.$store.state.process.app.deviceInfo)
        } else {
          param.append('device', 'pc')
        }
        param.append('cache_department_id', this.cache_department_id)
        param.append('company_id', this.company_id)
        param.append('project_id', this.details_project_id)

        param.append('evaluators', this.evaluators)
        const { data: res } = await this.$axios({
          method: 'post',
          url: '/api/Project/allocationl',
          data: param,
        })
        if (res.code != 200) return this.$message.error(res.datas.msg)
        this.$message.success(res.datas.msg)
        if (this.$route.query.from == 'myFlow') {
          this.$router.go(-1) //返回上一层
        }
        // this.$router.push('/project/index')
        this.getProjectStatus()
        this.getProjectDetails()
      }, this.timeDou)
    },
    // // *项目分配提交(以前老)
    // async distributionSubmit() {
    //   // if (!this.evaluators) return this.$message.error('请选择技术负责人')
    //   clearTimeout(this.tiemID)
    //   this.tiemID = setTimeout(async () => {
    //     let param = new URLSearchParams()
    //     param.append('member_id', this.member_id)
    //     param.1append('token', this.token)
    //     param.append('cache_department_id', this.cache_department_id)
    //     param.append('company_id', this.company_id)
    //     param.append('project_id', this.details_project_id)
    //     param.append('evaluators', this.evaluators)
    //     param.append('leader', this.leader)
    //     const { data: res } = await this.$axios({
    //       method: 'post',
    //       url: '/api/Project/allocation',
    //       data: param,
    //     })
    //     if (res.code != 200) return this.$message.error(res.datas.msg)
    //     this.$message.success(res.datas.msg)
    //     if (this.$route.query.from == 'myFlow') {
    //       this.$router.go(-1) //返回上一层
    //     }
    //     // this.$router.push('/project/index')
    //     this.getProjectStatus()
    //     this.getProjectDetails()
    //   }, this.timeDou)
    // },
    // *立项-项目分配-获取项目详情(当有projectid时)
    async getProjectDetails() {
      let param = new URLSearchParams()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('cache_department_id', this.cache_department_id)
      param.append('company_id', this.company_id)
      param.append('project_id', this.details_project_id)
      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/Project/allocation_detail',
        data: param,
      })
      this.addFormData = res.datas.info
      // 上传文件的处理
      if (this.addFormData.annex) {
        this.detailsImgList = this.addFormData.annex
        this.submitImgList = this.addFormData.annex
      }
      if (res.code != 200) return this.$message.error(res.datas.msg)
      this.isComponentsShow = true
      console.log('项目分配详情', this.addFormData)
    },
    transferChange(data, name) {
      this.evaluators = data
      this.evaluators_name = name
      console.log('自组建给父穿得选中的值', data, name)
    },
    transferChange1(data, name) {
      this.leader = data
      this.leader_name = name
      console.log('自组建给父穿得选中的值', data, name)
    },
    // 获取项目类型
    async getProjectTypeList() {
      let param = new URLSearchParams()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('cache_department_id', this.cache_department_id)
      param.append('company_id', this.company_id)
      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/Project/project_type',
        data: param,
      })
      if (res.code != 200) return this.$message.error(res.datas.msg)
      this.projectTypeList = res.datas.listInfo
      console.log('项目类型列表', this.projectTypeList)
    },
    upLoadChange(data) {
      console.log('文件列表', data)
      this.submitImgList = data
    },
    async getProjectStatus() {
      let param = new URLSearchParams()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('cache_department_id', this.cache_department_id)
      param.append('company_id', this.company_id)
      param.append('project_id', this.details_project_id)

      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/Project/get_project_status',
        data: param,
      })
      if (res.code != 200) return this.$message.error(res.datas.msg)
      this.details_project_status = res.datas.project_status
    },
  },
  created() {
    this.token = localStorage.getItem('btlh_process_token') || ''
    this.member_id = localStorage.getItem('btlh_process_member_id') || ''
    this.company_id = localStorage.getItem('bthl_process_LoginCompanyId') || ''
    this.cache_department_id =
      localStorage.getItem('bthl_process_cache_department_id_store') || ''
    this.getProjectTypeList()
    this.details_project_id = this.$route.query.project_id || ''
    if (this.details_project_id) {
      this.getProjectStatus()
      this.getProjectDetails()
    }
  },
  components: {
    OneTransfer,
    UploadFile,
    ProjectFlow,
    GoFinance,
  },
}
</script>
<style lang="less" scoped>
@import url(./projectForm.less);
</style>